export default "__VITE_ASSET__Dr$Nb44w__"